module.exports = __webpack_public_path__ + "static/img/band.95db7c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/band.png
// module id = JB9+
// module chunks = 1